/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variant_metafield = this.form.querySelector('[data-variantJSON-metafields]');
    this.variantPicker = this.dataset.type;
    this.variantDefaultPlans = this._loadVariantDefaultPlans();
  }

  connectedCallback() {
    // Show loader immediately for product pages - before any other processing
    if(this.formType == 'product-page') {
      this.showLoader();
    }
    
    // Element Connected callback
    if(this.formType == 'product-page') {
      this.onVariantChange('load');
      // Handle URL parameters for direct variant access
      this.handleUrlVariantParameter();
      
      // Handle single-variant products to default to second image if metafield is set
      this.handleSingleVariantSecondImage();
      
      // Fallback: only clear the loader here if Swiper is already initialised.
      // If Swiper hasn't loaded yet, global.js's sliderElement.connectedCallback
      // owns the reveal (fires loader-ready after init + correct-slide positioning).
      setTimeout(() => {
        if (productSlider) {
          this.hideLoader();
        }
      }, 100);
    }
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();

    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid, _event);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        const container = this.closest('[data-subscription-form]') ? this.closest('[data-subscription-form]') : productPage;
        this.renderProductInfo(this.currentVariant, container, _event);
      }

      this.updateURLandID(this.currentVariant);

      if (this.form.querySelectorAll('[data-onetime-price]').length) {
        this.form.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
          ele.innerHTML = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format);
        });
      }
    
      if(this.form.querySelector('[data-onetimes-price]')) {
        this.form.querySelector('[data-onetimes-price]').innerHTML = Utility.formatMoney(this.currentVariantGroup[0].price, window.globalVariables.money_format);
      }

      // Set onetime_compare_price attribute on page load and variant changes
      this.form.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
        let comparePrice = null;
        
        // Check selling_plan_allocations first, then regular compare_at_price
        if (this.currentVariant.selling_plan_allocations && this.currentVariant.selling_plan_allocations.length > 0 && this.currentVariant.selling_plan_allocations[0].compare_at_price) {
          comparePrice = this.currentVariant.selling_plan_allocations[0].compare_at_price;
        } else if (this.currentVariant.compare_at_price != null) {
          comparePrice = this.currentVariant.compare_at_price;
        }
        
        if (comparePrice != null) {
          let onetime_com_price = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
          ele.setAttribute("onetime_compare_price", onetime_com_price);
        } else {
          ele.setAttribute("onetime_compare_price", "");
        }
      });

      // Enable ATC button immediately so the browser can paint the interaction
      // response (variant selected, price updated, button enabled) before doing
      // the heavier subscription widget and savings work below.
      this.toggleAddButton('enable');

      if(_event != 'load') {
        // Update Supply
        if(this.formType == 'product-page'){
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
            let subscription_price = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
            if (ele.closest('[data-select-subscription_price]')) {
              let text = ele.innerText.split(window.globalVariables.money_format.replaceAll('{{amount}}',''));
              ele.innerText = `${text[0]} ${subscription_price}`;
            } else {
              ele.innerHTML = subscription_price;
            }

            if(this.currentVariant.compare_at_price != null){
              let subscription_compare = Utility.formatMoney(this.currentVariant.compare_at_price, window.globalVariables.money_format);
              ele.setAttribute("subscription_compare_price", subscription_compare);
            } else {
              let subscription_compare = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
              ele.setAttribute("subscription_compare_price", subscription_compare);
            }
          });
        }

        // Update onetime price
        _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
          let onetime_price = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format);
          ele.innerHTML = onetime_price;
        });

        // Update onetime discount striked price
        _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-onetime-discount-striked]').forEach((ele)=>{
          if(this.currentVariant.compare_at_price > this.currentVariant.price){
            let originalPrice = Utility.formatMoney(this.currentVariant.compare_at_price, window.globalVariables.money_format);
            ele.innerHTML = originalPrice;
          }else{
            ele.innerHTML = '';
          }
        });

        // Defer recharge widget updates — subscription UI is below the variant
        // selector and does not need to be in the same paint frame as the tap.
        // This allows the browser to commit the variant response first (INP).
        setTimeout(() => {
          if (this.form.querySelector('recharge-widget')) {
            // Filter selling plans based on current variant
            const rechargeWidget = this.form.querySelector('recharge-widget');
            if (rechargeWidget && typeof rechargeWidget.filterSellingPlansForVariant === 'function') {
              rechargeWidget.filterSellingPlansForVariant();
            }

            // Call methods directly on the recharge widget instance
            if (rechargeWidget && typeof rechargeWidget._toggleOptions === 'function') {
              rechargeWidget._toggleOptions(_event);
            }
            // Only call _changeSellingPlan when in subscription mode.
            // Calling it in one-time mode overwrites [data-current-price] and the
            // ATC button text with subscription pricing (even though later code
            // corrects it, the intermediate DOM corruption can cause visible flicker
            // and leaves the button text wrong if the correction path is skipped).
            const _currentPurchaseType = this.form
              .querySelector('[data-purchase_type] input[name="selling_plan"]:checked')
              ?.closest('[data-purchase_type]')
              ?.getAttribute('data-purchase_type');
            if (rechargeWidget && typeof rechargeWidget._changeSellingPlan === 'function'
                && _currentPurchaseType === 'subscription') {
              rechargeWidget._changeSellingPlan(_event);
            }
            let selectedItemType = this.form.querySelector('[data-purchase_type] input:checked')?.getAttribute('data-type') || 'onetime';
            if (selectedItemType == 'onetime') {
              const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
              const currentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-price]');
              if (onetimePriceElement && currentPriceElement) {
                let onetime_price = onetimePriceElement.innerHTML;
                currentPriceElement.innerHTML = onetime_price;
              }
            } else {
              let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
              this.form.closest('[data-product-container]').querySelector('[data-current-price]').innerHTML = subscription_price;

              const planInputs = Array.from(this.form.querySelectorAll('custom-select ul li input[type="radio"]'));
              // Prefer user's current frequency selection (e.g. 8 weeks) when switching back from one-time; only fall back to default when no valid selection
              const currentSelectionInput = this.form.querySelector('custom-select ul input[type="radio"]:checked') ||
                this.form.querySelector('[data-purchase_type="subscription"] input[name="selling_plan_group"]:checked') ||
                this.form.querySelector('.selling_plan li.selected input');
              const currentSelectionValid = currentSelectionInput && planInputs.includes(currentSelectionInput) && !this._isPlanOptionHidden(currentSelectionInput.closest('li'));

              let activePlanInput = null;
              if (currentSelectionValid) {
                activePlanInput = currentSelectionInput;
                this._applyPlanInputSelection(activePlanInput, planInputs);
              } else {
                activePlanInput = this._selectDefaultSellingPlan();
                if (!activePlanInput) {
                  activePlanInput = currentSelectionInput || this._findFirstVisiblePlanInput(planInputs);
                  if (activePlanInput) {
                    this._applyPlanInputSelection(activePlanInput, planInputs);
                  }
                }
              }
            }
          }
        }, 0);
      }

      // Defer bonus kit and savings calculations — below-fold content that does
      // not need to block the variant tap response frame.
      setTimeout(() => {
        this._updateBonusKit(this.currentVariant);

        // Calculate total savings including compare at price discount
        const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');
        let disV = rechargeInput ? rechargeInput.getAttribute('data-discount') : 0;

        const comparePrice = this.currentVariant.compare_at_price > this.currentVariant.price ? this.currentVariant.compare_at_price : this.currentVariant.price;
        const finalPrice = this.currentVariant.price - (this.currentVariant.price * disV / 100);
        const totalSavingsPercentage = Math.floor(((comparePrice - finalPrice) / comparePrice) * 100);

        // Calculate total discount amount (compare price discount + Recharge discount + shipping)
        const comparePriceDiscount = comparePrice - this.currentVariant.price;  // Savings from compare price
        let vPrice = this.currentVariant.price * disV / 100;  // Recharge discount
        let ship_rate = this.currentVariant.metafields.shipping_rate * 100 || 0;
        let totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate + vPrice), window.globalVariables.money_format);

        const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');

        if(shippingTextElement) {
          shippingTextElement.forEach(element => {
            if((ship_rate + vPrice) > 0) {
              const sep = element.classList.contains('freq-deal-banner') ? ' ' : '<br/> ';
              // element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping${sep}${totalDis} Total Savings`;
              element.innerHTML = `${totalSavingsPercentage}% off + Free US Shipping`;
            }
            // no-op when savings are zero: preserve existing shipping text
          });
        }

        // Update future subscription price (10% off compare_at_price)
        const futureSubscriptionPriceElement = document.querySelector('[data-future-subscription-price]');
        if (futureSubscriptionPriceElement) {
          const comparePriceText = this.form.querySelector('[data-onetime-price]').getAttribute("onetime_compare_price");
          if (comparePriceText && comparePriceText.length > 0) {
            // String parsing only works for "$" formats; prefer numeric variant
            // data (see rechargeWidget._changeSellingPlan) for non-USD safety.
            const comparePrice = parseFloat(comparePriceText.replace('$', '').replace(',', ''));
            const futureSubscriptionPrice = comparePrice * 0.9; // 10% off compare price
            futureSubscriptionPriceElement.textContent = Utility.formatMoney(futureSubscriptionPrice * 100, window.globalVariables.money_format);
          }
        }
      }, 0);
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }

  _loadVariantDefaultPlans() {
    const planScript = this.form?.querySelector('script[data-variant-default-plans]');
    if (!planScript) {
      return {};
    }

    try {
      const parsed = JSON.parse(planScript.textContent.trim());
      if (parsed && typeof parsed === 'object') {
        return parsed;
      }
    } catch (error) {
      console.warn('[VariantSelects] Unable to parse variant default plans – check script[data-variant-default-plans] JSON', error);
    }

    return {};
  }

  _getVariantDefaultPlanId(variantId) {
    if (!variantId) return null;
    const plans = this.variantDefaultPlans || {};
    const key = typeof variantId === 'number' ? variantId.toString() : variantId;
    const entry = plans[key];
    let planId = null;
    let source = null;
    let candidate = null;

    if (entry) {
      if (typeof entry === 'object') {
        planId = entry.plan_id || entry.id || null;
        source = entry.source || null;
        candidate = entry.candidate || null;
      } else {
        planId = entry;
      }
    }

    return planId;
  }

  _isPlanOptionHidden(li) {
    if (!li) return true;
    if (li.classList.contains('d-none') || li.classList.contains('hidden')) {
      return true;
    }
    if (typeof window !== 'undefined' && window.getComputedStyle) {
      const computedStyle = window.getComputedStyle(li);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || computedStyle.opacity === '0') {
        return true;
      }
    }
    return false;
  }

  _findFirstVisiblePlanInput(planInputs) {
    const fallback = planInputs.find((input) => {
      const li = input.closest('li');
      return li && !this._isPlanOptionHidden(li);
    }) || null;
    return fallback;
  }

  _applyPlanInputSelection(targetInput, planInputs) {
    if (!targetInput) return;
    const inputs = planInputs || Array.from(this.form.querySelectorAll('custom-select ul li input[type="radio"]'));

    inputs.forEach((input) => {
      const li = input.closest('li');
      const isActive = input === targetInput;
      input.checked = isActive;
      if (li) {
        li.classList.toggle('selected', isActive);
      }
    });

    const optionLabel = targetInput.closest('li')?.querySelector('.option_txt');
    const labelText = optionLabel ? optionLabel.textContent.trim() : '';
    const defaultLabel = this.form.querySelector('custom-select .default .option_txt');
    if (defaultLabel && labelText) {
      defaultLabel.textContent = labelText;
    }

    const sellingPlanInput = this.form.querySelector('.subscritpion_box input[name="selling_plan"]');
    if (sellingPlanInput) {
      sellingPlanInput.value = targetInput.value;
      sellingPlanInput.setAttribute('value', targetInput.value);
    }
  }

  _selectDefaultSellingPlan() {
    if (!this.form?.querySelector('recharge-widget')) {
      return null;
    }

    const currentVariantId = this.currentVariant && this.currentVariant.id ? this.currentVariant.id : null;
    const defaultPlanId = this._getVariantDefaultPlanId(currentVariantId);
    if (!defaultPlanId) {
      return null;
    }

    const planInputs = Array.from(this.form.querySelectorAll('custom-select ul li input[type="radio"]'));
    if (!planInputs.length) {
      return null;
    }

    let targetInput = planInputs.find((input) => input.value === defaultPlanId.toString());
    if (targetInput && this._isPlanOptionHidden(targetInput.closest('li'))) {
      targetInput = null;
    }

    if (!targetInput) {
      targetInput = this._findFirstVisiblePlanInput(planInputs);
    }

    if (targetInput) {
      this._applyPlanInputSelection(targetInput, planInputs);
    }

    return targetInput || null;
  }

  _updateBonusKit(currentVariant) {
    const wrapper = this.form?.querySelector('[data-bonus-kit-wrapper]');
    if (!wrapper) return;

    const bonusKitData = currentVariant?.metafields?.bonus_kit || null;
    const hasBonusKit = bonusKitData && typeof bonusKitData === 'object';

    const imageEl = wrapper.querySelector('[data-bonus-kit-image]');
    const titleEl = wrapper.querySelector('[data-bonus-kit-title]');
    const linkEl = wrapper.querySelector('[data-bonus-kit-link]');

    if (!hasBonusKit || !bonusKitData.title) {
      wrapper.classList.add('d-none');
      wrapper.setAttribute('aria-hidden', 'true');

      if (imageEl) {
        imageEl.removeAttribute('src');
        imageEl.alt = '';
      }
      if (titleEl) {
        titleEl.textContent = '';
      }
      if (linkEl) {
        linkEl.setAttribute('href', '#');
        linkEl.classList.add('d-none');
      }
      return;
    }

    wrapper.classList.remove('d-none');
    wrapper.removeAttribute('aria-hidden');

    if (titleEl) {
      titleEl.textContent = bonusKitData.title || '';
    }

    if (imageEl) {
      if (bonusKitData.product_image) {
        imageEl.src = bonusKitData.product_image;
      } else {
        imageEl.removeAttribute('src');
      }
      imageEl.alt = bonusKitData.product_alt || bonusKitData.title || '';
    }

    if (linkEl) {
      if (bonusKitData.product_url) {
        linkEl.href = bonusKitData.product_url;
        linkEl.classList.remove('d-none');
      } else {
        linkEl.setAttribute('href', '#');
        linkEl.classList.add('d-none');
      }
    }
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    this.currentVariantGroup = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    let variantsArray = this._getVariantData();
    
    let mappedValuesJson = [];
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(variant.options[0] === options[0]) {
        mappedValuesJson.push(variant);
      }

      if(!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
    this.currentVariantGroup = mappedValuesJson;
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') {
      // Preserve all existing query parameters (like tracking parameters)
      const urlParams = new URLSearchParams(window.location.search);
      // Update or add the variant parameter
      urlParams.set('variant', currentVariant.id);
      // Build the new URL with all parameters preserved
      const newUrl = `${this.dataset.url}?${urlParams.toString()}`;
      window.history.replaceState({ }, '', newUrl);
    }

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Update first-order pricing display based on variant selling plan allocations
   * @param {object} currentVariant 
   * @param {element} container 
   */
  updateFirstOrderPricing(currentVariant, container) {
    // Look in container first, then form (recharge-widget is inside the form)
    const firstOrderPricingElement = container?.querySelector('[data-first-order-pricing]') 
      || this.form?.querySelector('[data-first-order-pricing]');
    if (!firstOrderPricingElement) return;

    // Check if variant has selling plan allocations with price adjustments
    if (currentVariant.selling_plan_allocations && 
        currentVariant.selling_plan_allocations.length > 0) {
      
      const firstAllocation = currentVariant.selling_plan_allocations[0];

             // This is the metafield we set on the variant level to provide the discount amount after the first order for subs
       const futureOrderDiscount = currentVariant.metafields?.future_order_hardcoded_discount;
       
       if (futureOrderDiscount) {
         // Use metafield override
         this._displayFirstOrderPricingWithOverride(firstOrderPricingElement, firstAllocation, currentVariant, futureOrderDiscount);
       } else if (firstAllocation.price_adjustments && firstAllocation.price_adjustments.length >= 2) {
         // Use normal Recharge logic
         this._displayFirstOrderPricingNormal(firstOrderPricingElement, firstAllocation, currentVariant);
       } else {
         // No price adjustments - hide the element
         firstOrderPricingElement.style.display = 'none';
       }
    } else {
      // No selling plan allocations - hide the element
      firstOrderPricingElement.style.display = 'none';
    }
  }

  /**
   * Update product pricing based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  priceUpdate(currentVariant, container){
    
    let regularP = currentVariant.price;
    // Main product price element
    const priceElement = container.querySelector('[data-current-price]');
    const comparePriceElement = container.querySelector('[data-current-com-price]');

    
    if (priceElement) {
      priceElement.textContent = Utility.formatMoney(regularP, window.globalVariables.money_format);
    }

    let compareP = currentVariant.compare_at_price;
    
    if(compareP != null && comparePriceElement){
      const formattedComparePrice = Utility.formatMoney(compareP, window.globalVariables.money_format);
      comparePriceElement.textContent = formattedComparePrice;
      
      // Check if there's a real discount for display styling
      const hasRealDiscount = compareP > regularP;
      
      if (priceElement) {
        if (hasRealDiscount) {
          priceElement.classList.add('text-danger');
          comparePriceElement.style.display = '';
        } else {
          priceElement.classList.remove('text-danger');
          comparePriceElement.style.display = 'none';
        }
      }
    } else if (comparePriceElement) {
      // No compare price, hide the crossed-out price and remove red styling
      comparePriceElement.style.display = 'none';
      if (priceElement) {
        priceElement.classList.remove('text-danger');
      }
    }

    if(this.formType == 'product-page'){
      // Check if this is a subscription product (has recharge widget)
      const checkedInput = this.form.querySelector('.widget-options input:checked');
      
      if (checkedInput) {
        // This is a subscription product
        const purchaseType = checkedInput.closest('[data-purchase_type]');
        if (!purchaseType) return;
      
        const planType = purchaseType.getAttribute('data-purchase_type');
      
        if(planType == 'subscription') {
          let dis = this.form.querySelector('recharge-widget custom-select ul li input').getAttribute('data-discount') || 0;
          let discountPercentage = parseFloat(dis); 
          let discountedPrice = regularP - (regularP * discountPercentage / 100);
          
          // Round to nearest cent to match Recharge/Shopify backend rounding
          discountedPrice = Math.round(discountedPrice);
          
          if (priceElement) {
            priceElement.textContent = Utility.formatMoney(discountedPrice, window.globalVariables.money_format);
          }

          let subscriptionCompareP = currentVariant.selling_plan_allocations[0].compare_at_price;
          if(subscriptionCompareP != null && comparePriceElement) {
            comparePriceElement.textContent = Utility.formatMoney(subscriptionCompareP, window.globalVariables.money_format);
            
            // Check if there's a real discount for subscription
            const hasSubscriptionDiscount = subscriptionCompareP > discountedPrice;
            
            if (priceElement) {
              if (hasSubscriptionDiscount) {
                priceElement.classList.add('text-danger');
                comparePriceElement.style.display = '';
              } else {
                priceElement.classList.remove('text-danger');
                comparePriceElement.style.display = 'none';
              }
            }
          }
        }
      }
      // If no checked input found, this is a non-subscription product and we've already handled it above
    }
    // First-order pricing updated in renderProductInfo
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container, eventType) {
    if(!currentVariant || !container) {
      return;
    }

    this.updateOptionLabel(this.form); 

    // Handle variant image visibility for product pages
    if(this.formType == 'product-page') {
      this.updateVariantImageVisibility(currentVariant);
    }

    let imageToUse = currentVariant.featured_image;
    let mediaIdToUse = currentVariant.featured_media ? currentVariant.featured_media.id : null;

    if(imageToUse != null && this.formType != 'subscription') {
      if(this.formType == 'grid') {
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = imageToUse.src;
        featuredImage.srcset = imageToUse.src;
      } else {
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${mediaIdToUse}"]`);

        if (imageSlide) {
          let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
          if(productSlider) {
            productSlider.slideTo(slideIndex, 0, false);
          }
        }
      }
    }

    if(this.formType == 'product-page') {
      // Check if this product has subscription options (widget-options)
      const widgetOptions = this.form.querySelector('.widget-options input:checked');
      
      let planType = 'onetime'; // Default for non-subscription products
      let discountPercentage = 0;
      
      if (widgetOptions) {
        // This is a subscription product
        const purchaseType = widgetOptions.closest('[data-purchase_type]');
        if (purchaseType) {
          planType = purchaseType.getAttribute('data-purchase_type');
          let dis = planType == 'subscription' && this.form.querySelector('recharge-widget custom-select ul li input') ? this.form.querySelector('recharge-widget custom-select ul li input').getAttribute('data-discount') : 0;
          discountPercentage = parseFloat(dis) || 0;
        }
      } 

      if(currentVariant.options.length == 1 && container.querySelector('.custom-plan-wrapper[data-optionindex="1"]') != null) {
        if(currentVariant.metafields != null) {
          container.querySelectorAll('[data-size-desc]').forEach(x => x.textContent = `${currentVariant.metafields.serving_capacity}${ currentVariant.metafields.product_size_description ? `(${currentVariant.metafields.product_size_description})` : ''}`);
        }

        this.variantData.forEach((x) => {
            let regularP = x.price;
            let compareP = x.compare_at_price;
            
            // Use actual selling plan allocation price instead of calculating it
            let displayPrice = regularP;
            if (planType == 'subscription' && x.selling_plan_allocations && x.selling_plan_allocations.length > 0) {
              displayPrice = x.selling_plan_allocations[0].price;
            } else if (planType == 'subscription') {
              // Fallback to manual calculation if selling plan data not available
              displayPrice = regularP - (regularP * discountPercentage / 100);
              displayPrice = Math.round(displayPrice);
            }
            
            let discountPercent = Math.floor(((compareP - displayPrice) / compareP) * 100); // Calculate discount percentage based on difference between compare at compare at price and discounted price from RC 

            const grpPriceEl1 = container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-grp-price]`);
            if (grpPriceEl1) {
              grpPriceEl1.setAttribute('data-regular-price', x.price);
              grpPriceEl1.textContent = Utility.formatMoney(displayPrice, window.globalVariables.money_format);
            }
            // Determine the compare price to display synchronously:
            // 1. Use Shopify compare_at_price if it exceeds the regular price.
            // 2. For subscription products, fall back to data-plan-com-price (Recharge plan
            //    compare price) if no native compare price — prevents the element text from
            //    being cleared here only to be restored by the deferred _toggleOptions call,
            //    which was causing a visible layout jump (items collapsing 93px → 72px).
            {
              const grpComEl = container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-grp-com-price]`);
              if (grpComEl) {
                let comPriceToShow = x.compare_at_price > x.price ? x.compare_at_price : 0;
                if (!comPriceToShow && planType === 'subscription') {
                  const planCom = parseFloat(grpComEl.getAttribute('data-plan-com-price') || '0');
                  if (planCom > displayPrice) comPriceToShow = planCom;
                }
                grpComEl.textContent = comPriceToShow ? Utility.formatMoney(comPriceToShow, window.globalVariables.money_format) : '';
              }
            }

            const discountEl1 = container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-variant-discount]`);
            if (discountEl1) discountEl1.innerHTML = discountPercentage+"%";

            let finalDiscountPercent = 0;
            const discountPctEl1 = container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-variant-discount-percent]`);
            if(compareP < regularP) {
              finalDiscountPercent = discountPercentage;
              if (discountPctEl1) discountPctEl1.innerHTML = discountPercentage +"%";
            }else{
              finalDiscountPercent = discountPercent;
              if (discountPctEl1) discountPctEl1.innerHTML = discountPercent +"%";
            }
            
            // Hide discount wrapper if discount is 0%
            const labelElement = container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"]`);
            const discountWrapper = labelElement ? labelElement.closest('li').querySelector('.discount-wrapper') : null;
            if (discountWrapper) {
              if (finalDiscountPercent <= 0) {
                discountWrapper.classList.add("d-none");
              } else {
                discountWrapper.classList.remove("d-none");
              }
            }

          });

      } else {
        if(currentVariant.metafields != null)
          container.querySelectorAll('[data-size-desc]').forEach(x => x.textContent = `${currentVariant.metafields.serving_capacity}${ currentVariant.metafields.product_size_description ? `(${currentVariant.metafields.product_size_description})` : ''}`);
  
        if(container.querySelector('[data-optionindex="2"]')){
  
          this.currentVariantGroup.forEach((x) => {
            const grpPriceEl2 = container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-price]`);
            if (grpPriceEl2) grpPriceEl2.setAttribute('data-regular-price', x.price);

            // Compute display price early so it is available for compare price logic below.
            let displayPrice2 = x.price;
            if (planType === 'subscription') {
              if (x.selling_plan_allocations && x.selling_plan_allocations.length > 0) {
                displayPrice2 = x.selling_plan_allocations[0].price;
              } else {
                displayPrice2 = Math.round(x.price - (x.price * discountPercentage / 100));
              }
            }

            // Same compare-price logic as data-optionindex="1": fall back to
            // data-plan-com-price for subscription products so the element text is
            // never cleared only to be restored by the deferred _toggleOptions call.
            {
              const grpComEl = container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-com-price]`);
              if (grpComEl) {
                let comPriceToShow = x.compare_at_price > x.price ? x.compare_at_price : 0;
                if (!comPriceToShow && planType === 'subscription') {
                  const planCom = parseFloat(grpComEl.getAttribute('data-plan-com-price') || '0');
                  if (planCom > displayPrice2) comPriceToShow = planCom;
                }
                grpComEl.textContent = comPriceToShow ? Utility.formatMoney(comPriceToShow, window.globalVariables.money_format) : '';
              }
            }

            const grpSizeEl2 = container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-size]`);
            if (grpSizeEl2) grpSizeEl2.textContent = x.metafields.product_size_description ? `(${x.metafields.product_size_description})` : '';

            if(planType == 'subscription' ){
              const discountEl2 = container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-variant-discount]`);
              if (discountEl2) discountEl2.innerHTML = discountPercentage+"%";
              if (grpPriceEl2) grpPriceEl2.textContent = Utility.formatMoney(displayPrice2, window.globalVariables.money_format);
            } else {
              if (grpPriceEl2) grpPriceEl2.textContent = Utility.formatMoney(x.price, window.globalVariables.money_format);
            }

          });
        }
      }

    }

    // Main product price element for the check
    const priceElement = container.querySelector('[data-current-price]');
    if (priceElement) {
      this.priceUpdate(currentVariant, container);
    }
    // Always update first-order pricing (in recharge-widget) when element exists
    this.updateFirstOrderPricing(currentVariant, container);

    if(this.formType == 'product-page' && eventType != 'load'){
      this.renderIngredients(currentVariant, container);
    }
    
  }

  renderIngredients(currentVariant, container) {
    if(document.querySelector('[data-product-ingredients]') != null){
      const $el = document.querySelector('[data-product-ingredients]');
      if(currentVariant.metafields.ingredients.heading != ""){
        $el.querySelector('[data-ing-heading]').innerHTML = currentVariant.metafields.ingredients.heading;
      }

      if(currentVariant.metafields.ingredients.title != ""){
        $el.querySelector('[data-ing-title]').innerHTML = currentVariant.metafields.ingredients.title;
      }

      if(currentVariant.metafields.ingredients.sub_text != ""){
        $el.querySelector('[data-ing-sub-text]').innerHTML = currentVariant.metafields.ingredients.sub_text;
      }

      // Image-based ingredient display removed — supplement facts JSON cards
      // handle variant switching via supplement-facts-variant-switcher.js

      if(currentVariant.metafields.ingredients_list_item.length > 0 ){
        const html = currentVariant.metafields.ingredients_list_item.map(item => `
          <div class="d-flex flex-wrap mb-4 ingredients_card">
          ${item.image != null ? `<div class="ingredients_image">
                <img src="${item.image}" alt="${item.title}" width="250" height="250" loading="eager" class="img-contain">
            </div>` : '' }
            <div class="ingredients_details ps-xl-4 ps-3 ">
              <h3 class="fw-light h3 ls-0 mb-2 text-uppercase">${item.title}</h3>
              <div class="desc d-none d-sm-block">${item.caption}</div>
            </div>
            <div class="desc mt-2 d-block d-sm-none">${item.caption}</div>
          </div>
        `).join('');
        $el.querySelector('[data-ingredients-lists]').innerHTML = html;
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    
    // Check if variant should be forced out of stock or is unavailable
    const forceOutOfStock = this.currentVariant?.metafields?.force_out_of_stock === true;
    const isUnavailable = !this.currentVariant?.available;
    const shouldDisable = forceOutOfStock || isUnavailable;
    
    // if product is not available disable the add to cart button and update the text
    if (status == 'disable' || shouldDisable) {
      this.addBtn.setAttribute('disabled', true);

      // Determine the appropriate text based on the reason for being disabled
      let disabledText;
      if (forceOutOfStock || isUnavailable) {
        disabledText = window.variantStrings.soldOut;
      } else {
        disabledText = window.variantStrings.unavailable;
      }
      
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = disabledText;

      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.setAttribute('disabled', true);
        ele.innerHTML = disabledText;
      });
    } else {
      this.addBtn.removeAttribute('disabled');

      let isSubscription = false;
      document.querySelector('[data-product-container] recharge-widget')?.querySelectorAll('.widget-options').forEach((ele) => {
        if (ele.querySelector('input').checked) {
          isSubscription = ele.querySelector('input').getAttribute('data-type') == 'subscribe-only';
        }
      });

      let variantBtnText;
      if (isSubscription) {
        const rcInput = document.querySelector('[data-product-container] recharge-widget custom-select ul li input');
        const disV = rcInput ? parseFloat(rcInput.getAttribute('data-discount') || 0) : 0;
        variantBtnText = disV ? `Subscribe & save ${disV}%` : 'Subscribe & save';
      } else {
        variantBtnText = window.variantStrings?.addToCart || 'Add to cart';
      }

      this.addBtn.querySelector('.add-text').innerHTML = variantBtnText;
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.removeAttribute('disabled');
        ele.innerHTML = `<span class="add-text">${variantBtnText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
      });
    }
  }

  /**
   * Show loading state by hiding gallery
   */
  showLoader() {
    const imageGallery = document.querySelector('.product-images-wrapper');
    if(imageGallery) {
      imageGallery.classList.remove('loader-ready');
    }
  }

  /**
   * Hide loading state by showing gallery
   */
  hideLoader() {
    const imageGallery = document.querySelector('.product-images-wrapper');
    if(imageGallery) {
      imageGallery.classList.add('loader-ready');
    }
  }

  /**
   * Handle URL variant parameter to show correct images on page load
   */
  handleUrlVariantParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if(variantId) {
      // Find the variant by ID and update image visibility
      const variants = this._getVariantData();
      const selectedVariant = variants.find(variant => variant.id == variantId);
      
      if(selectedVariant) {
        this.updateVariantImageVisibility(selectedVariant);
      }
    }
  }

  /**
   * Handle single-variant products to default to second image if metafield is set
   */
  handleSingleVariantSecondImage() {
    const mainSliderEl = document.querySelector('[data-main-slider]');
    if (mainSliderEl && mainSliderEl.hasAttribute('data-disable-variant-images')) return;

    const productContainer = document.querySelector('[data-product-container]');
    const isSingleVariant = productContainer && productContainer.closest('.main-product-container').classList.contains('only-default-variant');
    if (!isSingleVariant) return;

    this.showLoader();

    const applySecondImageLogic = () => {
      const metafields = this.currentVariant && this.currentVariant.metafields;
      // Skip slide-1 navigation when PDP overlay is active (same guard as global.js)
      const hasOverlay = metafields &&
        ((metafields.cert_logos && metafields.cert_logos.length > 0) ||
         (metafields.slide_benefits && metafields.slide_benefits.length > 0));

      if (!hasOverlay &&
          metafields &&
          metafields.use_second_image_for_primary === true &&
          productSlider &&
          productSlider.slides &&
          productSlider.slides.length > 1) {
        productSlider.slideTo(1, 0);
      }
      this.hideLoader();
    };

    // Metafields are synchronously available (set by _getVariantData in setCurrentVariant).
    // The only dependency is productSlider — wait for pdp:slider:ready if not ready yet.
    if (productSlider) {
      applySecondImageLogic();
    } else {
      document.addEventListener('pdp:slider:ready', applySecondImageLogic, { once: true });
    }
  }

  /**
   * Update variant image visibility by removing and storing DOM elements
   * @param {object} currentVariant 
   */
  updateVariantImageVisibility(currentVariant) {
    if(!productSlider) {
      // Skip waiting and go directly to fallback method for faster response
      this.processVariantImagesWithoutSwiper(currentVariant);
      return;
    }
    
    this.processVariantImages(currentVariant);
  }

  processVariantImages(currentVariant) {
    // Get the current variant's handle (first option value).
    // Match Liquid's `handle` filter: replace all non-alphanumeric chars with dashes,
    // collapse consecutive dashes, and trim leading/trailing dashes.
    // Plain .replace(/\s+/g,'-') misses periods (e.g. "15.9oz" → "15-9oz" in Liquid
    // but "15.9oz" in JS), causing a selector mismatch and stranding slides in storage.
    const currentVariantHandle = currentVariant.options[0]
      ? currentVariant.options[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
      : null;
    
    // Create storage container if it doesn't exist
    let storageContainer = document.getElementById('variant-image-storage');
    if(!storageContainer) {
      storageContainer = document.createElement('div');
      storageContainer.id = 'variant-image-storage';
      storageContainer.style.display = 'none';
      document.body.appendChild(storageContainer);
    }
    
    // Get all ORIGINAL variant images — exclude Swiper loop clones (.swiper-slide-duplicate).
    // Swiper 11 clones slide elements verbatim (including all classes and data-variant-handle),
    // so the plain selector would inadvertently pull clones into storage and leave the loop
    // in a broken state.  Swiper's internal loopFix then fires after the next paint, shifting
    // the translate3d and making content below the slider (the swatch list) visually jump.
    const allVariantImages = document.querySelectorAll('.product--media[data-variant-handle]:not(.swiper-slide-duplicate)');

    // Remove all original variant images from slider and store them
    allVariantImages.forEach(image => {
      image.remove();
      storageContainer.appendChild(image);
    });

    // Add current variant's images back to the beginning of the slider
    if(currentVariantHandle) {
      const currentVariantImages = storageContainer.querySelectorAll(`.product--media[data-variant-handle="${currentVariantHandle}"]`);
      const swiperWrapper = document.querySelector('.product-carousel .swiper-wrapper');

      currentVariantImages.forEach((image, index) => {
        // Insert at the beginning (index 0) or after existing non-variant images
        const insertPosition = index;
        if(swiperWrapper.children[insertPosition]) {
          swiperWrapper.insertBefore(image, swiperWrapper.children[insertPosition]);
        } else {
          swiperWrapper.appendChild(image);
        }
      });
    }

    // Rebuild Swiper loop clones after DOM changes so the loop state stays consistent.
    // loopDestroy removes stale clones; loopCreate inserts fresh ones based on the updated
    // slide set.  This prevents Swiper's loopFix from firing post-paint and repositioning
    // the slider, which would shift page content (the swatch list) visibly.
    if (productSlider.params && productSlider.params.loop) {
      if (typeof productSlider.loopDestroy === 'function') productSlider.loopDestroy();
      if (typeof productSlider.loopCreate  === 'function') productSlider.loopCreate();
    }

    // Update Swiper layout, then slide to real index 0 using loop-aware slideToLoop.
    productSlider.update();
    if (productSlider.params && productSlider.params.loop && typeof productSlider.slideToLoop === 'function') {
      productSlider.slideToLoop(0, 0, false);
    } else {
      productSlider.slideTo(0, 0);
    }

    // Hide loader after variant images are set up
    this.hideLoader();
  }

  processVariantImagesWithoutSwiper(currentVariant) {
    // Match Liquid's `handle` filter — see processVariantImages for the full note.
    const currentVariantHandle = currentVariant.options[0]
      ? currentVariant.options[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
      : null;
    
    // Create storage container if it doesn't exist
    let storageContainer = document.getElementById('variant-image-storage');
    if(!storageContainer) {
      storageContainer = document.createElement('div');
      storageContainer.id = 'variant-image-storage';
      storageContainer.style.display = 'none';
      document.body.appendChild(storageContainer);
    }
    
    // Exclude Swiper loop clones (same reason as processVariantImages above).
    const allVariantImages = document.querySelectorAll('.product--media[data-variant-handle]:not(.swiper-slide-duplicate)');

    // Remove all original variant images from slider and store them
    allVariantImages.forEach(image => {
      image.remove();
      storageContainer.appendChild(image);
    });

    // Add current variant's images back to the beginning of the slider
    if(currentVariantHandle) {
      const currentVariantImages = storageContainer.querySelectorAll(`.product--media[data-variant-handle="${currentVariantHandle}"]`);
      const swiperWrapper = document.querySelector('.product-carousel .swiper-wrapper');

      currentVariantImages.forEach((image, index) => {
        // Insert at the beginning (index 0) or after existing non-variant images
        const insertPosition = index;
        if(swiperWrapper.children[insertPosition]) {
          swiperWrapper.insertBefore(image, swiperWrapper.children[insertPosition]);
        } else {
          swiperWrapper.appendChild(image);
        }
      });
    }

    // Hide loader after variant images are set up (without Swiper updates)
    this.hideLoader();
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);

    if(this.variantData) {
      this.variant_metafield_json = this.variant_metafield_json || JSON.parse(this.variant_metafield.textContent);
      
      this.variantData.forEach((x) => {
        x.metafields = this.variant_metafield_json[x.id];
      });
    }

    return this.variantData;
  }

  /**
   * Display first order pricing with metafield override
   * @param {element} firstOrderPricingElement 
   * @param {object} firstAllocation 
   * @param {object} currentVariant 
   * @param {number} futureOrderDiscount 
   */
  _displayFirstOrderPricingWithOverride(firstOrderPricingElement, firstAllocation, currentVariant, futureOrderDiscount) {
    const firstOrderPrice = firstAllocation.price_adjustments[0].price;
    const originalPrice = currentVariant.compare_at_price || currentVariant.price;
    
    // Calculate future order price using the metafield discount percentage
    const discountDecimal = parseInt(futureOrderDiscount) / 100;
    const calculatedFutureOrderPrice = originalPrice - (originalPrice * discountDecimal);
    
    // Calculate discount percentages
    const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
    const futureDiscountPercent = parseInt(futureOrderDiscount);
    
    // Update the pricing block with metafield override
    firstOrderPricingElement.innerHTML = `
      First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
      then <span class="secondary-order-price fw-bold">${Utility.formatMoney(calculatedFutureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
    `;
    
    // Show the element
    firstOrderPricingElement.style.display = '';
  }

  /**
   * Display first order pricing using normal Recharge logic
   * @param {element} firstOrderPricingElement 
   * @param {object} firstAllocation 
   * @param {object} currentVariant 
   */
  _displayFirstOrderPricingNormal(firstOrderPricingElement, firstAllocation, currentVariant) {
    const firstOrderPrice = firstAllocation.price_adjustments[0].price;
    const futureOrderPrice = firstAllocation.price_adjustments[1].price;
    const originalPrice = currentVariant.compare_at_price || currentVariant.price;
    
    // Only show pricing block if first order has a discount
    if (firstOrderPrice < futureOrderPrice) {
      // Calculate discount percentages
      const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
      const futureDiscountPercent = Math.round(((originalPrice - futureOrderPrice) / originalPrice) * 100);
      
      // Update the pricing block
      firstOrderPricingElement.innerHTML = `
        First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
        then <span class="secondary-order-price fw-bold">${Utility.formatMoney(futureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
      `;
      
      // Show the element
      firstOrderPricingElement.style.display = '';
    } else {
      // First order same as recurring - hide the element
      firstOrderPricingElement.style.display = 'none';
    }
  }
}
customElements.define('variant-selects', VariantSelects);
